export enum ExecutionTriggeredType {
  MANUAL = 'MANUAL',
  SCHEDULED = 'SCHEDULED',
  API = 'API',
}

export enum ExecutionTriggeredTypeTextMapping {
  'MANUAL' = 'Manual',
  'SCHEDULED' = 'Scheduled',
  'API' = 'API',
}
